module.exports = __webpack_public_path__ + "static/img/ESPN_lenova_port_lg.0da14b3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/lenovo-banner-campaign/ESPN_lenova_port_lg.jpg
// module id = 254
// module chunks = 2